<template>
  <!-- Comment box -->
  <v-card class="comment-box mt-4" elevation="1">
    <v-textarea
      class="mt-4"
      v-model="newComment"
      label="Írjon kommentet"
      rows="2"
      auto-grow
      variant="outlined"
      hide-details
    />
    <div class="comment-actions">
      <v-btn color="primary" @click="createComment">Küldés</v-btn>
    </div>
  </v-card>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { ActivityService } from "@/services/ActivityService";
import { useToast } from "@/services/useToast";
const props = defineProps<{
  publicReference: string;
}>();

const emit = defineEmits(["activity-created"]);
const activityService = new ActivityService("/admin/activities");
const { showToast } = useToast();
const newComment = ref("");

async function createComment() {
  try {
    await activityService.createAdminComment(
      newComment.value,
      props.publicReference
    );
    newComment.value = "";
    emit("activity-created");
    showToast("Komment elküldve");
  } catch {
    showToast("Komment küldése sikertelen", "error");
  }
}
</script>
<style scoped>
.comment-box {
  margin-top: 10px;
}
</style>
